AOS.init();

$(function () {
  console.log('Hello Bootstrap5');
  $('.owl-carousel').owlCarousel({
    loop:false,//循環
    margin:10,//邊距
    nav:false,//導航
    dots:true,//導航點
    responsive:{
      0:{
        items:1//數量
      },
      600:{
        items:2
      },
      1000:{
        items:4
      }
    }
  })

  $('.relative-img-pop').magnificPopup({
    // main options
    disableOn: 400,
    key: 'some-key',
    gallery: {
      // options for gallery
      enabled: true
    },
    image: {
      // options for image content type
      titleSrc: 'title'
    },
    type: 'image'
    // other options
  });


  //首頁輪播
  var swiper = new Swiper(".mySwiper", {
    spaceBetween: 30,
    effect: "fade",
    // navigation: {
    //   nextEl: ".swiper-button-next",
    //   prevEl: ".swiper-button-prev",
    // },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    autoplay: {
      loop: true,
      delay: 5000,
      disableOnInteraction: false,
    },
  });


  // 首頁最新消息的區塊
  var $tabButtonItem = $('#tab-button li'),
    $tabSelect = $('#tab-select'),
    $tabContents = $('.tab-contents'),
    activeClass = 'is-active';

  $tabButtonItem.first().addClass(activeClass);
  $tabContents.not(':first').hide();

  $tabButtonItem.find('a').on('click', function (e) {
    var target = $(this).attr('href');

    $tabButtonItem.removeClass(activeClass);
    $(this).parent().addClass(activeClass);
    $tabSelect.val(target);
    $tabContents.hide();
    $(target).show();
    e.preventDefault();
  });

  $tabSelect.on('change', function () {
    var target = $(this).val(),
      targetSelectNum = $(this).prop('selectedIndex');

    $tabButtonItem.removeClass(activeClass);
    $tabButtonItem.eq(targetSelectNum).addClass(activeClass);
    $tabContents.hide();
    $(target).show();
  });

});


